export const taskTypes = {
  NORMAL: 1,
  REVIEW: 2,
};
